/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestedByUserId
 */
export interface RequestedByUserId {
}

/**
 * Check if a given object implements the RequestedByUserId interface.
 */
export function instanceOfRequestedByUserId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RequestedByUserIdFromJSON(json: any): RequestedByUserId {
    return RequestedByUserIdFromJSONTyped(json, false);
}

export function RequestedByUserIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestedByUserId {
    return json;
}

export function RequestedByUserIdToJSON(value?: RequestedByUserId | null): any {
    return value;
}

